import React from "react";
import Select from "react-select";
import countries from "world-countries/countries.json";
import { StyledSelectWrapper } from "./styles";

// Map over countries and replace the USA country code
const countryOptions = countries.map((country) => ({
  label: country.name.common,
  value: country.cca3 === "USA" ? "330" : country.ccn3, // Replace USA's code with 330
}));

interface CountrySelectProps {
  name: string; // Accepts a name prop
  value: { label: string; value: string } | null;
  onChange: (
    name: string,
    selectedOption: { label: string; value: string } | null
  ) => void;
}

export const CountrySelect: React.FC<CountrySelectProps> = ({
  name,
  value,
  onChange,
}) => {
  return (
    <StyledSelectWrapper>
      <label>Country</label>
      <Select
        styles={{
          control: (baseStyles, state) => ({
            ...baseStyles,
            borderRadius: "8px",
          }),
        }}
        isSearchable
        isClearable
        options={countryOptions}
        value={value}
        onChange={(selectedOption) => onChange(name, selectedOption)} // Pass name along with value
        placeholder="Select your country"
        className="select-input"
      />
    </StyledSelectWrapper>
  );
};
